import React, { createContext, useContext, useState } from 'react';

// Create a context
const MyContext = createContext();

// Create a provider component
export function MyProvider({ children }) {
  // Define the initial state of the object
  const [myObject, setMyObject] = useState(null);

  // Create a function to update the object in the context
  const updateObject = (newObject) => {
    setMyObject(newObject);
  };

  // Provide the object and update function as values to the context
  const value = {
    myObject,
    updateObject,
  };

  return <MyContext.Provider value={value}>{children}</MyContext.Provider>;
}

// Create a custom hook for consuming the context
export function useMyContext() {
  return useContext(MyContext);
}
